function initAccessibleFilter({
  container = '.filter-contain',
  itemSelector = '.prod-card',
  filters = [],
  summaryTarget = '#a11y-filter-status',
  clearOnToggle = false,
  toggleButton = '.filter-toggle',
  filterPanel = '.press-on-filter',
  syncURL = true
}) {
  const $container = $(container);
  const $summary = $(summaryTarget);
  const $toggle = $container.find(toggleButton);
  const $panel = $container.find(filterPanel);

  // CHANGED: query items live so AJAX-appended cards (loaded past the 250
  // paginate cap) are always included, instead of a frozen init-time set.
  function getItems() {
    return $(itemSelector);
  }

  if ($toggle.length && $panel.length) {
    $toggle.attr('role', 'button').attr('aria-expanded', 'false').attr('tabindex', 0);

    $toggle.on('click keypress', function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
        $panel.toggle();
      }
    });
  }

  filters.forEach(f => {
    $container.on('change', f.selector, function () {
      applyFilterLogic();
      if (syncURL) updateURL();
    });
  });

  function getURLKey(f) {
    return f.urlKey || f.dataAttr;
  }

  function updateURL() {
    const params = new URLSearchParams(window.location.search);

    filters.forEach(f => {
      const key = getURLKey(f);
      const $checked = $container.find(`${f.selector}:checked`);

      if ($checked.length === 0) {
        params.delete(key);
      } else {
        const values = $checked.map(function () {
          return $(this).data('id');
        }).get();
        params.set(key, values.join(','));
      }
    });

    const qs = params.toString();
    const newURL = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({ filters: true }, '', newURL);
  }

  function applyFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    filters.forEach(f => {
      const key = getURLKey(f);
      if (!params.has(key)) return;

      const ids = (params.get(key) || '').split(',').filter(Boolean);

      $container.find(f.selector).each(function () {
        const id = String($(this).data('id'));
        $(this).prop('checked', ids.includes(id));
      });
    });
  }

function applyFilterLogic() {
    const $items = getItems();
    $items.show();

    filters.forEach(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return;

      // Selected checkbox ids, stringified for consistent comparison.
      const selected = new Set(
        $checked.map(function () { return String($(this).data('id')); }).get()
      );

      $items.filter(function () {
        // A product may carry multiple pipe-delimited values for a dimension
        // (e.g. "Spring|Summer"). Keep it if ANY value matches a selection.
        const raw = $(this).data(f.dataAttr);
        const values = String(raw == null ? '' : raw)
          .split('|')
          .map(v => v.trim())
          .filter(Boolean);
        return !values.some(v => selected.has(v));
      }).hide();
    });

    announceFilters($items);
  }

  function announceFilters($items) {
    $items = $items || getItems(); // CHANGED: accept passed set or re-query
    const visibleCount = $items.filter(':visible').length;

    const descriptions = filters.map(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return null;
      const labels = $checked.map(function () {
        return $(this).siblings('label').text().trim();
      }).get();
      return `${f.label}: ${labels.join(', ')}`;
    }).filter(Boolean);

    const summary = descriptions.length
      ? `Filters applied: ${descriptions.join('. ')}.`
      : 'No filters applied.';

    const result = visibleCount === 0
      ? 'No products match your filter selections.'
      : `${visibleCount} product${visibleCount > 1 ? 's' : ''} shown.`;

    $summary.text('');
    setTimeout(() => $summary.text(`${summary} ${result}`), 20);
  }

  if (syncURL) {
    $(window).on('popstate', function () {
      applyFiltersFromURL();
      applyFilterLogic();
    });
  }

  // CHANGED: re-apply once the AJAX loader has appended the rest of the products.
  document.addEventListener('collection:fully-loaded', function () {
    if (syncURL) applyFiltersFromURL();
    applyFilterLogic();
  });

  // Init: read URL → check boxes → filter
  if (syncURL) applyFiltersFromURL();
  applyFilterLogic();
}